<template>
  <div>
    <Loader v-if="loading"/>

    <Flash v-if="error" :message="error" type="danger" v-on:close="error = ''"/>
    <Flash v-if="success" :message="success" type="success" v-on:close="success = ''"/>

    <ul class="nav nav-pills my-3">
      <li
        v-for="(name, item) of views"
        :key="`drug-view-${item}`"
        class="nav-item">
        <a
          :class="`nav-link ${view === item ? 'active' : ''}`"
          @click="view = item">
          {{name}}
        </a>
      </li>
    </ul>

    <div v-if="view === 'list'">
      <ClientDrugList
        :prescriptions="current"
        title="Текущие назначения" />

      <ClientDrugList
        :prescriptions="past"
        title="Прошлые назначения"/>
    </div>

    <ClientDrugSchedule
      v-else-if="view === 'schedule'"
      :prescriptions="prescriptions"
      :times="times" />

    <ClientDrugShoplist
      v-else-if="view === 'shoplist'"
      :prescriptions="prescriptions" />
  </div>
</template>

<script>
import Loader from '../common/Loader';
import Flash from '../common/Flash';
import ClientDrugList from './drug/List';
import ClientDrugSchedule from './drug/Schedule';
import ClientDrugShoplist from './drug/Shoplist';

export default {
  name: 'ClientDrug',

  components: {
    Loader,
    Flash,
    ClientDrugList,
    ClientDrugSchedule,
    ClientDrugShoplist,
  },

  props: ['client'],

  data() {
    return {
      loading: false,
      error: '',
      success: '',
      view: 'list',
      views: {
        list: 'Список',
        schedule: 'График приема',
        shoplist: 'Лист покупок',
      },
    };
  },

  created() {
    this.loadData();
  },

  computed: {
    prescriptions() {
      const prescriptions = this.$store.getters.clientDrugPrescriptions(this.client.id);

      return prescriptions.map(prescription => {
        return prescription;
      });
    },

    current() {
      return this.prescriptions.filter(i => !i.isFinished());
    },

    past() {
      return this.prescriptions.filter(i => i.isFinished());
    },

    times() {
      return this.$store.state.drug.times;
    },
  },

  methods: {
    async loadData() {
      try {
        this.loading = true;

        await Promise.all([
          this.$store.dispatch('DRUG_LOAD_PRESCRIPTIONS', this.client.id),
          this.$store.dispatch('DRUG_LOAD_TIMES'),
        ]);
      } catch (e) {
        this.error = e.message;
      }

      this.loading = false;
    },
  },
};
</script>
